import { render, staticRenderFns } from "./copyAppoint.vue?vue&type=template&id=659486b2&scoped=true&"
import script from "./copyAppoint.vue?vue&type=script&lang=js&"
export * from "./copyAppoint.vue?vue&type=script&lang=js&"
import style0 from "./copyAppoint.vue?vue&type=style&index=0&id=659486b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659486b2",
  null
  
)

export default component.exports